import { resolveGutXAxisSystems } from '#components/GutXAxisBody/systems';
import type { GutXAxisOrgan } from '@repo/types';
import { useMemo } from 'react';
import styles from './GutXAxisOrganList.module.css';
import OrganRow from './OrganRow';

type GutXAxisOrganListProps = {
  organs: GutXAxisOrgan[];
  /** `kit.age_at_sampling`, in days. */
  age: number;
  pregnant: boolean;
  sex: string;
  /** Omit to render a static list, as the PDF report would. */
  onOrganSelect?: (organ: GutXAxisOrgan) => void;
};

/**
 * The body map as a list, for viewports where the map cannot be hovered or
 * usefully tapped. It resolves its organs through the map's own resolver, so it
 * can never name a system the body has no drawing for.
 */
export function GutXAxisOrganList({
  organs,
  age,
  pregnant,
  sex,
  onOrganSelect,
}: GutXAxisOrganListProps) {
  const { listedSystems, drawnCodes } = useMemo(
    () => resolveGutXAxisSystems({ organs, age, pregnant, sex }),
    [organs, age, pregnant, sex],
  );

  return (
    <ul className={styles.list}>
      {listedSystems.map(({ organ }) => (
        <OrganRow
          key={organ.id}
          organ={organ}
          age={age}
          pregnant={pregnant}
          sex={sex}
          drawnCodes={drawnCodes}
          onSelect={onOrganSelect ? () => onOrganSelect(organ) : undefined}
        />
      ))}
    </ul>
  );
}

export default GutXAxisOrganList;
